<template>
    <div class="summary-card">
        <div class="heading">
            {{ heading }}
        </div>
        <div class="number">
            <count-to :startVal="0" :endVal="parseInt(number,10)" :duration='2000' />
        </div> 
    </div>
</template>

<style lang="scss" scoped>
    @import "../../styles/vars.scss";
    .summary-card {
        margin-bottom:15px;
        text-align: center;

        .heading {
            font-weight: bold;
        }
        
        .number {
            font-size: 2rem;
            font-weight: bold;
            color: $color--main;
        }
    }
</style>

<script>
export default {
    props: [
        'heading',
        'number'
    ],
    components: {
    }
}
</script>



// WEBPACK FOOTER //
// SummaryCard.vue?48831c44